export default __webpack_public_path__ + "static/decklogs-4bebd83530fb7b0ea73456c449ff0eef.png";